import { navigateToUrl } from '../../common'
import { LANDING_ROUTE } from '../../common/routes'
import { removeRefreshToken, removeToken } from './token'

export const cleanupTokens = () => {
  removeToken()
  removeRefreshToken()
  navigateToUrl(LANDING_ROUTE)
}
